import $ from 'jquery';
import { emitter } from './../utils/custom-events.js';
import sbtech from './sbtech.api.client-1.0.js';
import sportsbookHelper from './sports-helper.js';
import login from './../login.js';
import {setNavigationCookies, sessionKey} from './../store/cookies.js';
import {eventType} from './../config/settings.js';
import './../libs/jquery-click-effect.js';

function logout(target) {
	login.doLogout(target);
}

function processLogoutSportsBook() {
	const tabBar = document.getElementsByClassName('tabs-bar')[0];
	const betTabs = tabBar.getElementsByClassName('js-my-bets');

	if (betTabs.length > 0) {
		for (let betTab of [...betTabs]) {
			betTab.remove();
		}
	}
}

function processAuthSportsBook() {
	if (!sessionKey()) {
		processLogoutSportsBook();
	}
}

function initEventListener() {
	emitter.on('logout', processLogoutSportsBook);
}

function scrollToTop() {
	document.getElementsByClassName('content pusher')[0].scrollTop = 0;
}

function init() {
	console.info('sportsbook init');
	sbtech.init();
	setNavigationCookies('sportsbook');

	initEventListener();
	processAuthSportsBook();

	//Click handlers for tabs
	$('#footerlink_home').on(eventType, () => {
		sbtech.api.client.gotoHome();
		scrollToTop();
	});

	$('#footerlink_search').on(eventType, () => {
		sbtech.api.client.gotoSearch();
		scrollToTop();
	});

	$('.icon-logout-stroke').off(eventType).on(eventType, function () {
		sbtech.api.client.logout();
		logout($(this));
	});

	$('#footerlink_bs').on(eventType, () => {
		sbtech.api.client.gotoBetslip();
		scrollToTop();
	});

	$('#footerlink_mybets').on(eventType, () => {
		sbtech.api.client.gotoBettingsHistory();
		scrollToTop();
	});

	$('#footerlink_bs_count').on('betsCounterChange', function () {
		const counter = parseInt($(this).text(), 10);

		$().clickEffect($(this), 'circle');

		if (counter >= 1) {
			$(this).removeClass('u-hide').addClass('u-show');
		} else {
			$(this).removeClass('u-show').addClass('u-hide');
		}
	});

	sbtech.api.client.registerLogoutCallback(logout);

	sbtech.api.client.registerStatusCallback(() => {
		sportsbookHelper.getStatus();
	});
}

const sportsbook = {
	init
};

export default sportsbook;



// WEBPACK FOOTER //
// ./mobile-core/src/sportsbook/sportsbook.js